// src/auth/authProvider.js
const API_URL = process.env.REACT_APP_TURUK_CLINIC_ADMIN_REST_API;

// Функция для сохранения токена
const storeToken = (token) => localStorage.setItem('auth_token', token);
const getToken = () => localStorage.getItem('auth_token');
const removeToken = () => localStorage.removeItem('auth_token');

export const authProvider = {
    // Вызывается при отправке формы логина
    login: async ({ username, password }) => {
        const request = new Request(`${API_URL}/auth/login`, {
            method: 'POST',
            body: JSON.stringify({ clinic_id: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        try {
            const response = await fetch(request);
            if (response.status < 200 || response.status >= 300) {
                throw new Error(response.statusText);
            }
            const { token, clinic_id, clinic_name } = await response.json();
            storeToken(token);
            // Сохраним также clinic_id и clinic_name, если нужны
            localStorage.setItem('clinic_id', clinic_id);
            localStorage.setItem('clinic_name', clinic_name);
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(new Error('Неверный ID клиники или пароль'));
        }
    },

    // Вызывается при нажатии на кнопку выхода
    logout: () => {
        removeToken();
        localStorage.removeItem('clinic_id');
        localStorage.removeItem('clinic_name');
        return Promise.resolve();
    },

    // Вызывается при каждой загрузке страницы для проверки, залогинен ли пользователь
    checkAuth: () => {
        return getToken() ? Promise.resolve() : Promise.reject();
    },

    // Вызывается при ошибках запросов (например, 401)
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            removeToken();
            return Promise.reject();
        }
        return Promise.resolve();
    },

    // Получение ролей/прав (пока не используется, вернём пустой объект)
    getPermissions: () => Promise.resolve(),
};

export default authProvider;